// extracted by mini-css-extract-plugin
export default {"comment-indicator":"SimpleDiff-module__comment-indicator--MoOJu"};